

$(document).ready(function () {
  

//     setTimeout(function() {
//       console.log('Running code'); 

//       $('ul.rebuy-cart__flyout-items li').each(function(index) {
//         var compare_price = parseFloat($('#cst-smartcart-' + index + ' span.rebuy-money.compare-at span.cart-rebuy-money').text());
//         var original_price = parseFloat($('#cst-smartcart-' + index + ' span.rebuy-money.sale span.cart-rebuy-money').text());
//         if(compare_price != 0){  
// console.log('hai');
//         var price_difference = compare_price - original_price;
//         var percentage_difference = (price_difference / compare_price) * 100;

//         console.log('Compare Price:', compare_price);
//         console.log('Original Price:', original_price);
//         console.log('Price Difference:', price_difference);
//         console.log('Percentage Difference:', Math.floor(percentage_difference) + '% off');
//         console.log('------------------');
//         $('#cst-smartcart-' + index + ' .cartDiscountInfo').html(Math.floor(percentage_difference) + '% off');
//         $('#cst-smartcart-' + index + ' .cartDiscountInfo').addClass('product-badge');
//  }
        
//       });
//     }, 5000);

//$("body").on('DOMSubtreeModified', "#rebuy-cart .rebuy-cart__flyout-content", function() {
// v5.8.9: the .cst-btnbtn % badge hook for the Rebuy drawer was removed; the native cart renders prices server-side.
  // $("body").on('DOMSubtreeModified', "#rebuy-cart .rebuy-cart__flyout-content", function() {
  //   console.log('changed');
  //   setTimeout(function() {
  //     console.log('Running code');
  //     $('ul.rebuy-cart__flyout-items li').each(function(index) {
  //       var compare_price = parseFloat($('#cst-smartcart-' + index + ' span.cst-compare-price').text());
  //       var original_price = parseFloat($('#cst-smartcart-' + index + ' span.cst-original-price').text());
  //       if(compare_price){
  //         console.log('hai');
  //       var price_difference = compare_price - original_price;
  //       var percentage_difference = (price_difference / compare_price) * 100;

  //       console.log('Compare Price:', compare_price);
  //       console.log('Original Price:', original_price);
  //       console.log('Price Difference:', price_difference);
  //       console.log('Percentage Difference:', Math.floor(percentage_difference) + '% off');
  //       console.log('------------------');
  //       $('#cst-smartcart-' + index + ' .cartDiscountInfo').html(Math.floor(percentage_difference) + '% off');
  //       $('#cst-smartcart-' + index + ' .cartDiscountInfo').addClass('product-badge');
  //         }
        
  //     });
  //   }, 1000);
  // });
// setTimeout(function(){
//       if($('#rebuy-cart .rebuy-cart__flyout-content').hasClass('no-items')){
//        console.log('asdasd');
//       var textcartnew = $(document).find('.collectionscarts').html();
//      //console.log(textcartnew);
//        $(document).find('.collectionscartnew').html(textcartnew);
//         }
//       else{
//         var slidernew = $(document).find('.slider-with-item').html();
//            $(document).find('.slider-with-item-new').html(slidernew);
//         $('#slick-slide-control81').trigger('click');
//       }
//         }, 6000);
  
  // v5.8.9: the Rebuy empty-cart injections (5.8 s / 6.0 s timers, .remove__btn) were removed; the native cart renders its own empty state.
 //  $("body").on('DOMSubtreeModified', "#rebuy-cart .rebuy-cart__flyout-content", function() {
 //     console.log('changed');

 //  var slidernew = $(document).find('.slider-with-item').html();
 //        $(document).find('.slider-with-item-new').html(slidernew);


 //        var textcartnew = $(document).find('.collectionscarts').html();
 //       $(document).find('.collectionscartnew').html(textcartnew);
 
 // });


  $(".megamenu-dropdown-btn").click(function () {
    $(this).closest(".mobile-menu-item").toggleClass("open");
    this.setAttribute("aria-expanded", $(this).closest(".mobile-menu-item").hasClass("open") ? "true" : "false");

    // flip the clicked item

    $(this).toggleClass("open");

    // animate a child of the parent to slide down. The parent is not the immediate parent though

    $(this)
      .closest(".mobile-menu-item")
      .children(".mobile-megamenu-dropdown")
      .slideToggle(300);
  });

  

  // $(".js-product-carousel-2").slick({
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   arrows: false,
  //   dots: true,
  //   infinite: false,
  //   speed: 500,
  //   cssEase: "ease",
  //   fade: true,
  //   responsive: [
  //     {
  //       breakpoint: 9999,
  //       settings: { dots: false, slidesToScroll: 1 },
  //     },
  //     {
  //       breakpoint: 1088,
  //       dots: true,
  //       settings: { slidesToShow: 1, slidesToScroll: 1 },
  //     },
  //   ],
  // });

});
// document.addEventListener('DOMContentLoaded', function() {
//     var button = document.getElementById('rewardbtn');
//     var tab = document.getElementById('rew-wrapper');

//     button.addEventListener('click', function() {
//         this.classList.toggle('active');
//     });
// });

